import Vuex from "vuex";
import _ from "lodash";
import User from "@/services/User";
import i18n from "@/services/i18n";
import jwt from "jsonwebtoken";

export default new Vuex.Store({
  state: {
    community: null,
    isJudge: false,
    token: null,

    user: null,
    userInfo: null,

    enrollmentStatuses: [
      { label: i18n.t("enrollments.statuses.waiting"), _id: "waiting" },
      { label: i18n.t("enrollments.statuses.reviewing"), _id: "reviewing" },
      { label: i18n.t("enrollments.statuses.confirmed"), _id: "confirmed" },
      { label: i18n.t("enrollments.statuses.rejected"), _id: "rejected" },
      { label: i18n.t("enrollments.statuses.canceled"), _id: "canceled" },
      { label: i18n.t("enrollments.statuses.alternate"), _id: "alternate" },
      {
        label: i18n.t("enrollments.statuses.pending_payment"),
        _id: "pending_payment",
      },
    ],
  },

  mutations: {
    setCommunity(state, community) {
      state.community = community;
    },
    clearCommunity(state) {
      state.community = null;
    },
    setToken(state, token) {
      state.token = token;
      state.user = jwt.decode(token);
    },
    setUser(state, user) {
      state.user = user;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    clearUserInfo(state) {
      state.userInfo = null;
    },
    clearToken(state) {
      state.token = null;
    },
    setIsJudge(state, isJudge) {
      state.isJudge = isJudge;
    },
    clearIsJudge(state) {
      state.isJudge = null;
    },
  },

  actions: {
    updateMe(context) {
      const userId = _.get(context.state, "userInfo._id", null);
      if (userId) {
        User.get(userId).then((result) => {
          context.commit("setUser", result.data);
        });
      }
    },
    getUserInfo(context, onSuccess = () => {}) {
      User.me().then((result) => {
        context.commit("setUserInfo", result.data);

        if (onSuccess && typeof onSuccess == "function") {
          onSuccess(result);
        }
      });
    },
  },

  getters: {
    filterSchemas(state) {
      return _.get(state, "userInfo.modules.schemas.filters", []);
    },
    isSuboperator(state) {
      return _.get(state, "userInfo.roles", []).includes("suboperator");
    },
    isChiefJudge(state) {
      return _.get(state, "userInfo.roles", []).includes(
        "robotics:chief:judge",
      );
    },
    isCommittee(state) {
      return _.get(state, "userInfo.roles", []).includes("robotics:committee");
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js